import React from 'react';
import PropTypes from 'prop-types';

import {OEMediaCenterItemTypes} from '../oe-media-center-model';
import OEMediaCenterItemStd from './oe-media-center-item-std';
import OEMediaCenterItemPres from './oe-media-center-item-pres';

export class OEMediaCenterItemFactory extends React.PureComponent {

    render() {
        return (this.props.item.type.value === OEMediaCenterItemTypes.presentation && this.props.usePresItems ? 
            <OEMediaCenterItemPres {...this.props}/> :
            <OEMediaCenterItemStd {...this.props}/>
        );
    }
}

OEMediaCenterItemFactory.defaultProps = Object.assign({
    usePresItems: true
}, OEMediaCenterItemStd.defaultProps, OEMediaCenterItemPres.defaultProps);

OEMediaCenterItemFactory.propTypes = Object.assign({
    usePresItems: PropTypes.bool
}, OEMediaCenterItemStd.propTypes, OEMediaCenterItemPres.propTypes);
